"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _CarouselSlide = _interopRequireDefault(require("./CarouselSlide"));

var _CarouselControl = _interopRequireDefault(require("./CarouselControl"));

var _CarouselIndicator = _interopRequireDefault(require("./CarouselIndicator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Carousel = (_ref) => {
  let {
    size,
    pxSize,
    minimal,
    children,
    onCarouselClick,
    hideIndicators,
    showZoomOverlay,
    zoomOverlayContent,
    className,
    style,
    landscape,
    currentSlide,
    onSlideChanged
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["size", "pxSize", "minimal", "children", "onCarouselClick", "hideIndicators", "showZoomOverlay", "zoomOverlayContent", "className", "style", "landscape", "currentSlide", "onSlideChanged"]);

  const total = _react.default.Children.count(children);

  const pixels = size && !minimal ? sizeMap[size].pxWidth : pxSize;
  const allowNavigation = minimal && total > 1;
  const isLandscape = minimal ? false : landscape;
  /**
   * State and control for slides
   */

  const [slideState, setSlideState] = (0, _react.useState)({
    currentSlide: currentSlide > total - 1 ? 0 : currentSlide,
    previousSlide: null,
    transitioning: false,
    timer: null,
    direction: ''
  });
  (0, _react.useEffect)(() => {
    setSlideState(previousState => {
      if (currentSlide !== undefined && previousState.currentSlide !== currentSlide) {
        const slideNumber = currentSlide < 0 || currentSlide >= total ? previousState.currentSlide : currentSlide;
        return _objectSpread(_objectSpread({}, previousState), {}, {
          currentSlide: slideNumber
        });
      }

      return previousState;
    });
  }, [currentSlide, total]);

  const clearPendingAnimation = () => {
    if (slideState.timer) {
      clearTimeout(slideState.timer);
    }
  };

  const endAnimation = () => setTimeout(() => setSlideState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
    previousSlide: null,
    transitioning: false
  })), 600);

  const goToSlide = (nextSlide, direction) => {
    if (nextSlide === slideState.currentSlide) {
      return;
    }

    clearPendingAnimation();
    setSlideState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      direction: direction || nextSlide > slideState.currentSlide ? 'next' : 'prev',
      previousSlide: prevState.currentSlide,
      currentSlide: nextSlide,
      transitioning: true,
      timer: endAnimation()
    }));
    onSlideChanged && onSlideChanged(nextSlide);
  };

  const goToNextSlide = () => {
    let nextSlide = slideState.currentSlide + 1;

    if (nextSlide >= _react.default.Children.count(children)) {
      nextSlide = 0;
    }

    goToSlide(nextSlide, 'next');
  };

  const goToPreviousSlide = () => {
    const nextSlide = slideState.currentSlide > 0 ? slideState.currentSlide - 1 : _react.default.Children.count(children) - 1;
    goToSlide(nextSlide, 'prev');
  };

  const slides = _react.default.Children.map(children, (child, i) => /*#__PURE__*/_react.default.createElement(_CarouselSlide.default, {
    active: i === slideState.currentSlide,
    index: i,
    animateOut: i === slideState.previousSlide && slideState.transitioning,
    animateIn: i === slideState.currentSlide && slideState.previousSlide !== null && slideState.transitioning,
    direction: slideState.direction,
    onCarouselClick: onCarouselClick,
    showZoomOverlay: showZoomOverlay,
    zoomOverlayContent: zoomOverlayContent
  }, child));

  const componentStyle = isLandscape ? {
    height: `${pixels}px`,
    display: 'flex',
    flexDirection: 'row-reverse',
    width: 'fit-content'
  } : {
    width: `${pixels}px`
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: className,
    style: _objectSpread(_objectSpread({}, componentStyle), style)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    style: isLandscape ? {
      width: `${pixels}px`
    } : {
      height: `${pixels}px`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "carousel slide"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "carousel-inner",
    role: "listbox"
  }, slides && slides.length ? slides : null))), !hideIndicators && /*#__PURE__*/_react.default.createElement("div", {
    className: `carousel-navigation${minimal ? ' carousel-navigation-small' : ''}${isLandscape ? ' carousel-navigation-vertical' : ''}`
  }, /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
    disabled: !allowNavigation,
    onClick: goToPreviousSlide,
    large: !minimal,
    direction: isLandscape ? 'up' : 'left',
    hintText: "Previous"
  }), /*#__PURE__*/_react.default.createElement("ol", {
    className: "carousel-indicators",
    style: {
      height: 'auto',
      overflow: 'visible'
    }
  }, total && minimal ? /*#__PURE__*/_react.default.createElement("div", {
    className: "small"
  }, total > 0 ? `${slideState.currentSlide + 1} / ${total}` : '– / –') : /*#__PURE__*/_react.default.createElement("li", {
    disabled: true,
    style: {
      backgroundColor: '#edf3f8'
    }
  })), /*#__PURE__*/_react.default.createElement(_CarouselControl.default, {
    disabled: !allowNavigation,
    onClick: goToNextSlide,
    large: !minimal,
    direction: isLandscape ? 'down' : 'right',
    hintText: "Next"
  })));
};

Carousel.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(['xs', 's', 'm', 'l', 'xl']),
  pxSize: _propTypes.default.number,
  minimal: _propTypes.default.bool,
  children: _propTypes.default.node,
  onCarouselClick: _propTypes.default.func,
  currentSlide: _propTypes.default.number,
  landscape: _propTypes.default.bool,
  onSlideChanged: _propTypes.default.func,
  hideIndicators: _propTypes.default.bool,
  showZoomOverlay: _propTypes.default.bool,
  style: _reactStyleProptype.default,
  zoomOverlayContent: _propTypes.default.node
};
Carousel.defaultProps = {
  size: 'm',
  pxSize: 200,
  minimal: false,
  currentSlide: 0,
  landscape: false,
  hideIndicators: false,
  showZoomOverlay: false
};
var _default = Carousel;
exports.default = _default;